import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Course, CourseParticipant } from '../dataTypes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CourseService {
  constructor(private http: HttpClient) {}
  /**
   * Gets all courses from database
   * @returns
   */
  getCourses(): Observable<Course[]> {
    return this.http.get<Course[]>('/api/course');
  }

  /**
   * Updates courses in database with the use of a list Course[] and a userId for eventlog, to see who made the change
   * @param course
   * @param userId
   * @returns
   */
  upsertCourse(course: Course): Observable<Course> {
    if (course.id === 0) {
      return this.http.post<Course>('/api/Course', course);
    } else {
      return this.http.put<Course>('/api/Course', course);
    }
  }

  /**
   * Deletes a Course database value with the use of a Course object and a userId for eventlog, to see who deleted Course
   * @param delCourse
   * @param userId
   * @returns
   */
  deleteCourse(delCourse: Course): Observable<Course> {
    const options = {
      body: delCourse, // Add delCourse in the body
    };
    return this.http.delete<Course>('/api/course', options);
  }
}
